import { render, staticRenderFns } from "./addFeePrintSpec.vue?vue&type=template&id=220fbf2f"
import script from "./addFeePrintSpec.vue?vue&type=script&lang=js"
export * from "./addFeePrintSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports